import React from "react";
import Navbar from "../components/header/Navbar";
type Props = {};

const Albums = (props: Props) => {
  return (
    <div>
      {/* <Navbar /> */}
      !!Working on albums feature 🚧 🚧 🚧 🚧
    </div>
  );
};

export default Albums;
